import { render, staticRenderFns } from "./budgetItemPop.vue?vue&type=template&id=71dafaa7"
import script from "./budgetItemPop.vue?vue&type=script&lang=js"
export * from "./budgetItemPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71dafaa7')) {
      api.createRecord('71dafaa7', component.options)
    } else {
      api.reload('71dafaa7', component.options)
    }
    module.hot.accept("./budgetItemPop.vue?vue&type=template&id=71dafaa7", function () {
      api.rerender('71dafaa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetItemPop.vue"
export default component.exports